import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import OnboardingShell from './OnboardingShell';
import { saveOnboardingStep } from './samples';

const STEPS = [
  { color: 'text-[#ff9a6c]', titleKey: 'onboarding.welcome.step1Title', descKey: 'onboarding.welcome.step1Desc' },
  { color: 'text-[#b892ff]', titleKey: 'onboarding.welcome.step2Title', descKey: 'onboarding.welcome.step2Desc' },
  { color: 'text-[#ff6f91]', titleKey: 'onboarding.welcome.step3Title', descKey: 'onboarding.welcome.step3Desc' },
  { color: 'text-[#ff9a6c]', titleKey: 'onboarding.welcome.step4Title', descKey: 'onboarding.welcome.step4Desc' },
] as const;

export default function WelcomePage() {
  const { t } = useTranslation();
  const { user } = useAuth();

  useEffect(() => {
    saveOnboardingStep('/onboarding', user?.id);
  }, [user?.id]);

  return (
    <OnboardingShell title={t('onboarding.welcome.title')} maxWidth={620}>
      <div className="text-center">
        <div className="mb-8 flex items-center justify-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#ff6f91] text-lg font-bold text-[#1c1420]">
            L
          </div>
          <span className="text-2xl font-bold">Loopcast</span>
        </div>

        <h1 className="m-0 mb-6 text-[44px] font-extrabold leading-[1.2] tracking-[-0.03em]">
          {t('onboarding.welcome.title')}
        </h1>
        <p className="mb-8 text-lg leading-relaxed text-[#c9b8d1]">
          {t('onboarding.welcome.subtitlePre')}{' '}
          <span className="font-bold text-[#ff6f91]">{t('onboarding.welcome.subtitleEm')}</span>
          {t('onboarding.welcome.subtitlePost')}
        </p>

        <div className="mb-10 grid grid-cols-2 gap-4">
          {STEPS.map((s) => (
            <div key={s.titleKey} className="rounded-xl border border-[#2b1f33] bg-[#221733] p-5 text-left">
              <div className={`mb-2 text-[13px] font-bold ${s.color}`}>{t(s.titleKey)}</div>
              <div className="text-[13px] text-[#c9b8d1]">{t(s.descKey)}</div>
            </div>
          ))}
        </div>

        <Link
          to="/onboarding/tone"
          className="inline-block w-full rounded-lg bg-[#ff6f91] px-8 py-3.5 text-center text-base font-bold text-[#2b0e18] transition-colors hover:bg-[#ff85a3]"
        >
          {t('onboarding.welcome.cta')}
        </Link>
      </div>
    </OnboardingShell>
  );
}
